var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"card"},[_c('TabView',[_c('TabPanel',{attrs:{"header":"รายละเอียดข้อมูลเจ้าหน้าที่"}},[_c('report-officer-detail')],1),_c('TabPanel',{attrs:{"header":"สรุปจำนวนเจ้าหน้าที่"}},[_c('report-officer-amount')],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }